import { createContext, useState, useContext } from 'react';
import PropTypes from 'prop-types';

// Створення контексту
const TrenerNameContext = createContext();

// Хук для доступу до контексту
export const useTrenerName = () => {
  return useContext(TrenerNameContext);
};

// Провайдер контексту
export const TrenerNameProvider = ({ children }) => {
  const [trainerName, setTrenerName] = useState('');
  const [trainerPrice, setTrenerPrice] = useState('');

  const resetTrenerName = () => {
    setTrenerName('');
    setTrenerPrice('');
  };

  return (
    <TrenerNameContext.Provider
      value={{
        trainerName,
        trainerPrice,
        setTrenerPrice,
        setTrenerName,
        resetTrenerName,
      }}
    >
      {children}
    </TrenerNameContext.Provider>
  );
};

TrenerNameProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
